// extracted by mini-css-extract-plugin
module.exports = {"nomatch":"nomatch_nomatch__2y-j5"};